<template>
  <div class="guarantor-detail">
    <Header class="header" v-if="showHeader">
      <Menu mode="horizontal" theme="dark" active-name="1" class="top-bar">
        <div class="layout-logo">
          <img src="./../../assets/logo.png" height="42" style="margin-right:10px;">
          <div class="site-name-area">
            <h2 class="inline font-white">{{getConfig('TITLE')}}</h2>
            <div class="small font-grey">{{getConfig('SUBTITLE')}}</div>
          </div>
        </div>
        <div class="layout-nav">
        </div>
        <div class="pull-right" style="margin-right:20px">
          <Tooltip content="登录系统">
            <Button type="text" ghost @click="$router.push('/welcome')" icon="md-exit">登录系统</Button>
          </Tooltip>
        </div>
      </Menu>
    </Header>
    <div :style="showHeader?'padding:16px':''">
      <div class="detail-header">
        <h2>
          {{guarantorModel.name}}
          <Tag v-if="guarantorModel&&guarantorModel.type"
            color="primary">
            {{$common.guarantorType[guarantorModel.type.toString()]}}
          </Tag>
          <Tag v-if="guarantorStatus!==null"
            :color="$common.guarantorStatusColor[guarantorStatus.toString()]">
            {{$common.guarantorStatus[guarantorStatus.toString()]}}
          </Tag>
        </h2>
        <Alert show-icon type="error" v-if="guarantorModel&&guarantorModel.status===40">
          该机构被列入黑名单！
          <template slot="desc">
            <p v-if="guarantorModel&&guarantorModel.blacklistReason">
              原因：<span v-html="guarantorModel.blacklistReason"></span>
            </p>
            <p v-if="guarantorModel&&guarantorModel.blacklistFacts">
              违规事实：<span v-html="guarantorModel.blacklistFacts"></span>
            </p>
            <p v-if="guarantorModel&&guarantorModel.blacklistExpires">
              黑名单结束时间：{{require('moment')(guarantorModel.blacklistExpires).format('YYYY-MM-DD')}}
            </p>
          </template>
        </Alert>
        <div class="header-actions">
          <ButtonGroup style="margin-right: 10px">
            <Button v-if="checkRolePermitted(['总监管人','监管人'])&&guarantorModel&&guarantorModel.status==3&&checkSpvMng('canAuditGuarantor')"
              @click="setAllowance">
              <Icon type="md-create" />
              设置额度</Button>
            <Button v-if="checkRolePermitted(['总监管人','监管人'])&&guarantorModel&&guarantorModel.status==3&&checkSpvMng('canAuditGuarantor')"
              @click="setAddCity">
              <Icon type="md-pin" />
              增加区域</Button>
            <Button v-if="checkRolePermitted(['总监管人','监管人'])&&guarantorModel&&guarantorModel.status==3&&checkSpvMng('canAuditGuarantor')"
              @click="setAddIndustry">
              <Icon type="md-build" />
              增加行业</Button>
            <Button
              v-if="checkRolePermitted(['监管人','总监管人'])
                &&guarantorModel
                &&guarantorModel.status===3
                &&checkSpvMng('canBlacklistGuarantor')"
              @click="showSetExceptionModal=true">
              <Icon type="md-remove-circle" />
              加入黑名单</Button>
            <Button
              v-if="checkRolePermitted(['监管人','总监管人'])
                &&guarantorModel
                &&guarantorModel.status===40
                &&checkSpvMng('canBlacklistGuarantor')"
              @click="submitRemoveException">
              <Icon type="md-remove-circle" />
              解除黑名单</Button>
            <Button
              v-if="checkRolePermitted(['监管人','总监管人'])&&guarantorModel&&guarantorModel.status==2&&(checkSpvMng('canAuditGuarantor')||checkSpvMng('canPreAuditGuarantor'))"
              :to="`/guarantors/detail/${$route.params.guarantorId}/preview`">
              <Icon type="md-print" />
              打印备案表</Button>
            <Button
              v-if="checkRolePermitted(['监管人','总监管人'])&&guarantorModel&&guarantorModel.status==2&&checkSpvMng('canAuditGuarantor')"
              @click="auditPass">
              <Icon type="md-create" />
              审核</Button>
            <Button
              v-if="checkRolePermitted(['监管人','总监管人'])&&guarantorModel&&guarantorModel.status==2&&checkSpvMng('canAuditGuarantor')"
              @click="auditDeny">
              <Icon type="md-create" />
              退回</Button>
            <Button
              v-if="checkRolePermitted(['监管人','总监管人'])&&guarantorModel&&guarantorModel.status==1&&checkSpvMng('canPreAuditGuarantor')"
              @click="preAuditPass">
              <Icon type="md-create" />
              预审</Button>
            <Button
              v-if="checkRolePermitted(['监管人','总监管人'])&&guarantorModel&&guarantorModel.status==1&&checkSpvMng('canPreAuditGuarantor')"
              @click="preAuditDeny">
              <Icon type="md-create" />
              退回</Button>
            <Button
              v-if="checkRolePermitted(['监管人','总监管人'])&&guarantorModel&&(checkSpvMng('canAuditGuarantor')||checkSpvMng('canPreAuditGuarantor'))"
              @click="goToStatistics">
              <Icon type="ios-analytics" />
              数据统计</Button>
            <Button
              v-if="checkRolePermitted(['监管人','总监管人'])&&guarantorModel&&(checkSpvMng('canAuditGuarantor')||checkSpvMng('canPreAuditGuarantor'))"
              @click="goToGuaranteeList">
              <Icon type="ios-navigate" />
              查看保函</Button>
            <Button
              @click="getGuarantorDetail">
              <Icon type="md-refresh" />
              刷新</Button>
          </ButtonGroup>
          
        </div>
      </div>
      <div class="detail-body">
        <Tabs type="card" class="tab-square" :animated="false" v-if="guarantorModel&&guarantorModel.name" v-model="curTab">
          <TabPane label="基本信息" name="basic">
            <table class="brief-table">
              <tbody>
                <tr>
                  <td class="title">保证人名称</td>
                  <td colspan="3">{{guarantorModel.name}}</td>
                  <td class="title">保证人类型</td>
                  <td>{{$common.guarantorType[guarantorModel.type.toString()]}}</td>
                </tr>
                <tr>
                  <td class="title">机构代码</td>
                  <td>{{guarantorModel.code||'未设置'}}</td>
                  <td class="title">审核人</td>
                  <td>{{guarantorModel.auditorName}}</td>
                  <td class="title">审核时间</td>
                  <td>{{guarantorModel.auditTime?require('moment')(guarantorModel.auditTime).format('YYYY-MM-DD HH:mm:ss'):null}}</td>
                </tr>
                <tr v-if="guarantorModel.comment">
                  <td class="title">审核意见</td>
                  <td colspan="5">{{guarantorModel.comment}}</td>
                </tr>
                <tr>
                  <td class="title">社会信用代码</td>
                  <td>{{guarantorModel.businessLicense}}</td>
                  <td class="title">注册资金(万元)</td>
                  <td>{{guarantorModel.capital}}</td>
                  <td class="title">成立日期</td>
                  <td>{{guarantorModel.estDate?require('moment')(guarantorModel.estDate).format('YYYY-MM-DD'):null}}</td>
                </tr>
                <tr>
                  <td class="title">实缴资本(万元)</td>
                  <td>{{guarantorModel.capitalPaidIn}}</td>
                  <td class="title">实缴出资日期</td>
                  <td>{{guarantorModel.capitalPaidInDate?require('moment')(guarantorModel.capitalPaidInDate).format('YYYY-MM-DD'):null}}</td>
                  <td class="title">注册类型</td>
                  <td>{{guarantorModel.corpType}}</td>
                </tr>
                <tr>
                  <td class="title">认缴资本(万元)</td>
                  <td>{{guarantorModel.capitalSubscribed}}</td>
                  <td class="title">认缴出资日期</td>
                  <td>{{guarantorModel.capitalSubscribedDate?require('moment')(guarantorModel.capitalSubscribedDate).format('YYYY-MM-DD'):null}}</td>
                  <td class="title"></td>
                  <td></td>
                </tr>
                <tr>
                  <td class="title">营业地址</td>
                  <td colspan="3">{{guarantorModel.address}}</td>
                  <td class="title">邮编</td>
                  <td>{{guarantorModel.postCode}}</td>
                </tr>
                <tr v-if="guarantorModel.scope">
                  <td class="title">营业范围</td>
                  <td colspan="5">{{guarantorModel.scope}}</td>
                </tr>
                <tr>
                  <td class="title">公司网址</td>
                  <td colspan="3">{{guarantorModel.homePage}}</td>
                  <td class="title">Email</td>
                  <td>{{guarantorModel.email}}</td>
                </tr>
                <tr v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
                  <td class="title">偿付充足率信息</td>
                  <td colspan="3">{{guarantorModel.solvency}}</td>
                  <td class="title">保证业务总量</td>
                  <td>{{guarantorModel.totalGuaAmount}}万元</td>
                </tr>
                <tr>
                  <td class="title">联系人</td>
                  <td>{{guarantorModel.contact}}</td>
                  <td class="title">电话</td>
                  <td>{{guarantorModel.contactTel}}</td>
                  <td class="title">传真</td>
                  <td>{{guarantorModel.fax}}</td>
                </tr>
                <tr>
                  <td class="title">性别</td>
                  <td>{{guarantorModel.contactGender?'男':'女'}}</td>
                  <td class="title">部门</td>
                  <td>{{guarantorModel.contactDept}}</td>
                  <td class="title">职务</td>
                  <td>{{guarantorModel.contactRole}}</td>
                </tr>
                <tr>
                  <td class="title">法定代表人</td>
                  <td>{{guarantorModel.legalPersonName}}</td>
                  <td class="title" v-if="[2,3,10].indexOf(guarantorModel.type)>-1">电话</td>
                  <td colspan="3" v-if="[2,3,10].indexOf(guarantorModel.type)>-1">{{guarantorModel.legalPersonTel}}</td>
                  <td class="title" v-if="[2,3,10].indexOf(guarantorModel.type)===-1">职务</td>
                  <td v-if="[2,3,10].indexOf(guarantorModel.type)===-1">{{guarantorModel.legalPersonRole}}</td>
                  <td class="title" v-if="[2,3,10].indexOf(guarantorModel.type)===-1">职称</td>
                  <td v-if="[2,3,10].indexOf(guarantorModel.type)===-1">{{guarantorModel.legalPersonTitle}}</td>
                </tr>
                <tr>
                  <td class="title">性别</td>
                  <td>{{guarantorModel.legalPersonGender?'男':'女'}}</td>
                  <td class="title">学历</td>
                  <td>{{guarantorModel.legalPersonEduBackground}}</td>
                  <td class="title">政治面貌</td>
                  <td>{{guarantorModel.legalPersonPolitical}}</td>
                </tr>
                <tr v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
                  <td class="title">管理人员</td>
                  <td>{{guarantorModel.supervisorContactPerson}}</td>
                  <td class="title">电话</td>
                  <td colspan="3">{{guarantorModel.supervisorContactTel}}</td>
                </tr>
                <tr v-if="[2,3,10].indexOf(guarantorModel.type)>-1">
                  <td class="title">管理机构</td>
                  <td>{{guarantorModel.supervisorName}}</td>
                  <td class="title">电话</td>
                  <td colspan="3">{{guarantorModel.supervisorTel}}</td>
                </tr>
                <tr v-if="guarantorModel.type===1">
                  <td class="title">总经理</td>
                  <td>{{guarantorModel.generalManagerName}}</td>
                  <td class="title">职务</td>
                  <td>{{guarantorModel.generalManagerRole}}</td>
                  <td class="title">职称</td>
                  <td>{{guarantorModel.generalManagerTitle}}</td>
                </tr>
                <tr v-if="guarantorModel.type===1">
                  <td class="title">专职从业人员</td>
                  <td>{{guarantorModel.qualifiedTotal}}</td>
                  <td class="title">财务人员</td>
                  <td>{{guarantorModel.cpaTotal}}</td>
                  <td class="title">法务工作人员</td>
                  <td>{{guarantorModel.solicitorTotal}}</td>
                </tr>
                <!-- <tr>
                  <td class="title">员工总数</td>
                  <td>{{guarantorModel.employeeTotal}}</td>
                  <td class="title">有职称</td>
                  <td>{{guarantorModel.titledTotal}}</td>
                  <td class="title">中高级职称</td>
                  <td>{{(guarantorModel.titledMedTotal||0)+(guarantorModel.titledSeniorTotal||0)}}</td>
                </tr>
                <tr>
                  <td class="title">注册监理工程师</td>
                  <td>{{guarantorModel.regSupervTotal}}</td>
                  <td class="title">注册建造师</td>
                  <td>{{guarantorModel.regConstrTotal}}</td>
                  <td class="title">注册造价师</td>
                  <td>{{guarantorModel.regCostTotal}}</td>
                </tr>
                <tr>
                  <td class="title">项目经理</td>
                  <td>{{guarantorModel.prjManagerTotal}}</td>
                  <td class="title">注册会计师</td>
                  <td>{{guarantorModel.cpaTotal}}</td>
                  <td class="title">律师</td>
                  <td>{{guarantorModel.solicitorTotal}}</td>
                </tr> -->
                <tr v-if="guarantorModel.guarRange">
                  <td class="title">担保经营范围</td>
                  <td colspan="6">{{guarantorModel.guarRange}}</td>
                </tr>
                <tr v-if="guarantorModel.introduction">
                  <td class="title" colspan="6">企业简介</td>
                </tr>
                <tr v-if="guarantorModel.introduction">
                  <td colspan="6">{{guarantorModel.introduction}}</td>
                </tr>
              </tbody>
            </table>
          </TabPane>
          <TabPane label="额度信息" name="allowance" v-if="checkRolePermitted(['监管人','总监管人'])&&(checkSpvMng('canAuditGuarantor')||checkSpvMng('canPreAuditGuarantor'))">
            <Row :gutter="16">
              <i-col span="12">
                <i-circle
                  :size="250"
                  :trail-width="4"
                  :stroke-width="5"
                  :percent="getAvaliablePercent"
                  stroke-linecap="square"
                  stroke-color="#43a3fb">
                  <div class="balance-circle">
                    <h1>{{Math.round(calcBalance/10000)/100}}万</h1>
                    <p>已用额度</p>
                    <span>
                      占比
                      <b><i>{{getAvaliablePercent}}%</i></b>
                    </span>
                    <p>总额度:{{Math.round(guarantorModel.allowance/10000)/100}}万</p>
                    <p v-if="guarantorModel.singleLimit>=0">单笔限额:{{Math.round(guarantorModel.singleLimit/10000)/100}}万</p>
                    <p v-if="guarantorModel.minRate>=0">最低费率:{{Math.round(guarantorModel.minRate/10000)/100}}%·月</p>
                  </div>
                </i-circle>
              </i-col>
              <i-col span="12">
                <Form label-position="right" :label-width="120">
                  <FormItem label="总额度">
                    <!-- <Progress :percent="getAvaliablePercent" :stroke-width="32" text-inside /> -->
                    <span>{{Math.round(guarantorModel.allowance/10000)/100}}万</span>
                  </FormItem>
                  <FormItem label="已用额度">
                    <span>{{Math.round(calcBalance/10000)/100}}万</span>
                    <Tooltip content="刷新">
                      <Button type="text" shape="circle"
                        @click="updateCalculatedBalance"
                        size="small" icon="ios-refresh"></Button>
                    </Tooltip>
                  </FormItem>
                  <FormItem label="在保笔数">
                    <span>{{undergoingCount}}</span>
                  </FormItem>
                  <FormItem label="在保担保额度">
                    <span>{{Math.round(undergoingBalance/10000)/100}}万</span>
                    <Tooltip content="刷新">
                      <Button type="text" shape="circle"
                        @click="updateUndergoingBalance"
                        size="small" icon="ios-refresh"></Button>
                    </Tooltip>
                  </FormItem>
                  <FormItem label="累计笔数">
                    <span>{{cumulativeCount}}</span>
                  </FormItem>
                  <FormItem label="累计担保额度">
                    <span>{{Math.round(cumulativeBalance/10000)/100}}万</span>
                    <Tooltip content="刷新">
                      <Button type="text" shape="circle"
                        @click="updateCumulativeBalance"
                        size="small" icon="ios-refresh"></Button>
                    </Tooltip>
                  </FormItem>
                </Form>
              </i-col>
            </Row>
          </TabPane>
          <TabPane label="附件" name="attachments"
            v-if="checkRolePermitted(['监管人','总监管人'])&&(checkSpvMng('canAuditGuarantor')||checkSpvMng('canPreAuditGuarantor'))&&(guarantorModel.attachments&&guarantorModel.attachments instanceof Array&&guarantorModel.attachments.length)">
            <div v-for="(att,idx) in guarantorModel.attachments" :key="idx">
              <Divider>{{att.name}}</Divider>
              <div class="attachments">
                <div class="attachment-thumb"
                  :key="idx"
                  v-for="(img,idx) in att.url">
                  <img :src="img.url" @click="handleImgPreview(att.url, idx)" v-if="img&&img.url&&img.type==='image'">
                  <span style="font-weight:bold;color:#999;padding:10px;cursor:pointer" @click="previewImgUrl=img;showPreview=true" v-if="img&&img.url&&img.type==='file'">{{img.surfix.toUpperCase()}}</span>
                </div>
              </div>
            </div>
          </TabPane>
          <TabPane label="业务区域" name="regional" v-if="checkRolePermitted(['监管人','总监管人'])&&(checkSpvMng('canAuditGuarantor')||checkSpvMng('canPreAuditGuarantor'))">
            <Table border ref="regionalTable"
              size="small"
              stripe
              :columns="myCitiesColumns"
              :data="myCities">
            </Table>
          </TabPane>
          <TabPane label="业务行业/领域" name="industrial" v-if="checkRolePermitted(['监管人','总监管人'])&&(checkSpvMng('canAuditGuarantor')||checkSpvMng('canPreAuditGuarantor'))">
            <Table border ref="industrialTable"
              size="small"
              stripe
              :columns="industryRecordsColumns"
              :data="industryRecords">
            </Table>
          </TabPane>
          <TabPane label="用户" name="user" v-if="checkRolePermitted(['监管人','总监管人'])&&(checkSpvMng('canAuditGuarantor')||checkSpvMng('canPreAuditGuarantor'))">
            <Form ref="newUserForm" :model="newUserModel" inline>
              <FormItem prop="userId" :rules="[{required:true,message:'请选择用户',trigger:'blur'}]">
                <Select v-model="newUserModel.userId" filterable :transfer="true" placeholder="选择用户">
                  <Option v-for="item in users" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem prop="isAdmin">
                <i-switch v-model="newUserModel.isAdmin" size="large">
                  <span slot="open">管理员</span>
                  <span slot="close">普通</span>
                </i-switch>
              </FormItem>
              <FormItem>
                <Button type="primary" @click="addUser">增加</Button>
              </FormItem>
            </Form>
            <Table border ref="userTable"
              size="small"
              stripe
              :columns="userColumns"
              :data="userList">
            </Table>
          </TabPane>
        </Tabs>
      </div>
    </div>
    <div class="padding-top-20"></div>
    <Row :gutter="16" style="margin-bottom:20px;" v-if="checkRolePermitted(['监管人','总监管人'])&&guarantorModel.status==2&&(checkSpvMng('canAuditGuarantor'))">
      <i-col span="12">
        <Button type="primary"
          long size="large"
          @click="auditPass">
          <Icon type="md-create" />
          审核</Button>
      </i-col>
      <i-col span="12">
        <Button type="error"
          long size="large"
          @click="auditDeny">
          <Icon type="md-create" />
          退回</Button>
      </i-col>
    </Row>
    <Row :gutter="16" style="margin-bottom:20px;" v-if="checkRolePermitted(['监管人','总监管人'])&&guarantorModel.status==1&&(checkSpvMng('canPreAuditGuarantor'))">
      <i-col span="12">
        <Button type="primary"
          long size="large"
          @click="preAuditPass">
          <Icon type="md-create" />
          预审通过</Button>
      </i-col>
      <i-col span="12">
        <Button type="error"
          long size="large"
          @click="preAuditDeny">
          <Icon type="md-create" />
          退回</Button>
      </i-col>
    </Row>
    <Footer v-if="showHeader" style="text-align:center" />
    <CertSelectModal
      :show="showCertSelectModal"
      :dataSigning="dataToSign"
      :mode="signMode"
      @cert-verified="certSigned"
      :callback="signCallback"
      @close-modal="showCertSelectModal=false" />
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null" width="1200">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <iframe :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix==='pdf'" width="100%" height="800"></iframe>
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'&&previewImgUrl.surfix!='pdf'">查看</a>
    </Modal>
    <Modal v-model="showSetExceptionModal"
      scrollable
      :mask="true"
      :mask-closable="false"
      @on-cancel="closeSetExceptionModal"
      title="加入黑名单">
      <Form ref="setExceptionForm" :model="setExceptionModel"
        label-position="left"
        :label-width="120">
        <FormItem label="加入理由" prop="reason">
          <Input v-model="setExceptionModel.reason"
            maxlength="1000"
            show-word-limit
            type="textarea"
            placeholder="输入加入黑名单的理由" 
            />
        </FormItem>
        <FormItem label="违规事实" prop="facts">
          <Input v-model="setExceptionModel.facts"
            maxlength="1000"
            show-word-limit
            type="textarea"
            placeholder="陈述违规事实" 
            />
        </FormItem>
        <FormItem label="黑名单截止日" prop="expires">
          <Date-picker type="date"
            v-model="setExceptionModel.expires"
            placeholder="YYYY-MM-DD"
            style="width: 150px"></Date-picker>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submitSetException">提交</Button>
        <Button @click="closeSetExceptionModal">取消</Button>
      </div>
    </Modal>
    <Modal v-model="showSetAllowanceModal"
      scrollable
      :mask="true"
      :mask-closable="false"
      @on-cancel="closeSetAllowanceModal"
      title="设置额度">
      <Form ref="setAllowanceForm" :model="setAllowanceModel"
        label-position="left"
        :label-width="120">
        <FormItem label="最低费率(%·月)" prop="minRate">
          <InputNumber :min="-1" :step="0.1" style="width: 200px"
              :formatter="value => `${value}%`"
              v-model="setAllowanceModel.minRate" placeholder="最低担保月费率(%)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="单笔限额(万元)" prop="singleLimit">
          <InputNumber :min="-1" style="width: 200px"
            v-model="setAllowanceModel.singleLimit" :step="100" placeholder="单笔限额(万元)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="总限额(万元)" prop="allowance" :rules="[{required:true,type:'number',message:'不能为空',trigger:'blur'}]">
          <InputNumber :min="0" style="width: 200px"
            v-model="setAllowanceModel.allowance" :step="1000" placeholder="总限额(万元)"></InputNumber>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submitSetAllowance">提交</Button>
        <Button @click="closeSetAllowanceModal">取消</Button>
      </div>
    </Modal>
    <Modal v-model="showAddCityModal"
      scrollable
      :mask="true"
      :mask-closable="false"
      @on-cancel="closeAddCityModal"
      title="设置开展业务区域">
      <Form ref="addCityForm" :model="addCityModel"
        label-position="left"
        :label-width="140">
        <FormItem label="地区" prop="cityId" v-if="!addCityModel.id" :rules="[{required:true,type:'number',message:'不能为空',trigger:'blur'}]">
          <Cascader :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择"></Cascader>
        </FormItem>
        <FormItem label="担保种类(多选)" prop="varieties" :rules="[{required:true,validator:arrayValidator,trigger:'change'}]">
          <Select v-model="addCityModel.varieties" filterable multiple>
            <Option v-for="(tp,idx) in varieties" :key="idx" :value="parseInt(tp.id)">{{tp.fullName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="最低费率(%·月)" prop="minRate">
          <InputNumber :min="-1" :step="0.1" style="width: 200px"
              :formatter="value => `${value}%`"
              v-model="addCityModel.minRate" placeholder="最低担保月费率(%)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="区域单笔限额(万元)" prop="singleLimit">
          <InputNumber :min="-1" style="width: 200px"
            v-model="addCityModel.singleLimit" :step="100" placeholder="区域单笔限额(万元)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="区域限额(万元)" prop="regionalAllowance">
          <InputNumber :min="0" style="width: 200px"
            v-model="addCityModel.regionalAllowance" :step="1000" placeholder="区域限额(万元)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submitAddCity">提交</Button>
        <Button @click="closeAddCityModal">取消</Button>
      </div>
    </Modal>
    <Modal v-model="showAddIndustryModal"
      scrollable
      :mask="true"
      :mask-closable="false"
      @on-cancel="closeAddIndustryModal"
      title="设置开展业务行业/领域">
      <Form ref="addIndustryForm" :model="addIndustryModel"
        label-position="left"
        :label-width="140">
        <FormItem label="地区" prop="cityId" v-if="!addIndustryModel.id" :rules="[{required:true,type:'number',message:'不能为空',trigger:'blur'}]">
          <Cascader :data="cities" :load-data="loadCityData" @on-change="cityIndustrySelected" placeholder="选择"></Cascader>
        </FormItem>
        <FormItem label="行业/领域" prop="industryId" v-if="!addIndustryModel.id" :rules="[{required:true,type:'number',message:'不能为空',trigger:'blur'}]">
          <Select v-model="addIndustryModel.industryId" filterable placeholder="选择行业/领域">
            <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="担保种类(多选)" prop="varieties" :rules="[{required:true,validator:arrayValidator,trigger:'change'}]">
          <Select v-model="addIndustryModel.varieties" filterable multiple>
            <Option v-for="(tp,idx) in varieties" :key="idx" :value="parseInt(tp.id)">{{tp.fullName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="最低费率(%·月)" prop="minRate">
          <InputNumber :min="-1" :step="0.1" style="width: 200px"
              :formatter="value => `${value}%`"
              v-model="addIndustryModel.minRate" placeholder="最低担保月费率(%)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="区域单笔限额(万元)" prop="singleLimit">
          <InputNumber :min="-1" style="width: 200px"
            v-model="addIndustryModel.singleLimit" :step="100" placeholder="区域单笔限额(万元)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="区域限额(万元)" prop="regionalAllowance">
          <InputNumber :min="0" style="width: 200px"
            v-model="addIndustryModel.regionalAllowance" :step="1000" placeholder="区域限额(万元)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submitAddIndustry">提交</Button>
        <Button @click="closeAddIndustryModal">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="auditRegionalModal"
      title="审核区域保证人">
      <Form ref="auditRegionalForm" :model="auditRegionalModel" v-if="auditRegionalModel&&auditRegionalModel.id"
        label-position="left"
        :label-width="120">
        <FormItem label="审核通过" prop="pass">
          <i-switch v-model="auditRegionalModel.pass" size="large">
            <span slot="open">通过</span>
            <span slot="close">拒绝</span>
          </i-switch>
        </FormItem>
        <FormItem label="拒绝原因"
          prop="comment"
          v-if="!auditRegionalModel.pass"
          :rules="!auditRegionalModel.pass?[{required:true,message:'请输入拒绝原因',trigger:'blur'}]:null">
          <Input v-model="auditRegionalModel.comment" placeholder="输入拒绝原因" />
        </FormItem>
        <FormItem label="最低费率(%·月)" prop="minRate" v-if="auditRegionalModel.pass">
          <InputNumber :min="0" :step="0.1" style="width: 200px"
              :formatter="value => `${value}%`"
              v-model="auditRegionalModel.minRate" placeholder="最低担保月费率(%)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="单笔限额(万元)" prop="singleLimit" v-if="auditRegionalModel.pass">
          <InputNumber :min="0" style="width: 200px"
            v-model="auditRegionalModel.singleLimit" :step="1" placeholder="单笔限额(万元)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="区域限额(万元)" prop="regionalAllowance" v-if="auditRegionalModel.pass">
          <InputNumber :min="0" style="width: 200px"
            v-model="auditRegionalModel.regionalAllowance" :step="1" placeholder="区域限额(万元)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="担保种类" prop="varieties" v-if="auditRegionalModel.pass">
          <Select v-model="auditRegionalModel.varieties" filterable multiple>
            <Option v-for="(tp,idx) in varieties" :key="idx" :value="parseInt(tp.id)">{{tp.fullName}}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submitAuditRegional">审核</Button>
        <Button @click="closeAuditRegionalModal">关闭</Button>
      </div>
    </Modal>
    <Modal
      v-model="auditIndustrialModal"
      title="审核行业领域保证人">
      <Form ref="auditIndustrialForm" :model="auditIndustrialModel" v-if="auditIndustrialModel&&auditIndustrialModel.id"
        label-position="left"
        :label-width="120">
        <FormItem label="审核通过" prop="pass">
          <i-switch v-model="auditIndustrialModel.pass" size="large">
            <span slot="open">通过</span>
            <span slot="close">拒绝</span>
          </i-switch>
        </FormItem>
        <FormItem label="拒绝原因"
          prop="comment"
          v-if="!auditIndustrialModel.pass"
          :rules="!auditIndustrialModel.pass?[{required:true,message:'请输入拒绝原因',trigger:'blur'}]:null">
          <Input v-model="auditIndustrialModel.comment" placeholder="输入拒绝原因" />
        </FormItem>
        <FormItem label="最低费率(%·月)" prop="minRate" v-if="auditIndustrialModel.pass">
          <InputNumber :min="0" :step="0.1" style="width: 200px"
              :formatter="value => `${value}%`"
              v-model="auditIndustrialModel.minRate" placeholder="最低担保月费率(%)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="单笔限额(万元)" prop="singleLimit" v-if="auditIndustrialModel.pass">
          <InputNumber :min="0" style="width: 200px"
            v-model="auditIndustrialModel.singleLimit" :step="1" placeholder="单笔限额(万元)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="区域限额(万元)" prop="regionalAllowance" v-if="auditIndustrialModel.pass">
          <InputNumber :min="0" style="width: 200px"
            v-model="auditIndustrialModel.regionalAllowance" :step="1" placeholder="区域限额(万元)"></InputNumber>
          <span class="font-grey small">-1为不限</span>
        </FormItem>
        <FormItem label="担保种类" prop="varieties" v-if="auditIndustrialModel.pass">
          <Select v-model="auditIndustrialModel.varieties" filterable multiple>
            <Option v-for="(tp,idx) in varieties" :key="idx" :value="parseInt(tp.id)">{{tp.fullName}}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submitAuditIndustrial">审核</Button>
        <Button @click="closeAuditRegionalModal">关闭</Button>
      </div>
    </Modal>
    <image-preview
      :minScale="1"
      :image-urls="imageUrls"
      :visible.sync="visiblePreviewer"
      :start-position="startPosition"></image-preview>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
import CertSelectModal from './../../components/CertSelectModal'
import Footer from '@/components/Footer.vue'
export default {
  name: 'guarantor-detail',
  props: {
  },
  components: {
    CertSelectModal,
    Footer
  },
  data () {
    return {
      showHeader: false,
      loading: false,
      curTab: '',
      guarantorStatus: null,
      guarantorModel: {
        id: null,
        name: null,
        businessLicense: null,
        legalPersonName: null,
        allowance: null,
        singleLimit: null,
        minRate: null,
        contact: null,
        contactTel: null,
        regCity: null,
        address: null,
        email: null,
        postCode: null,
        capital: null,
        estDate: null,
        scope: null,
        homePage: null,
        fax: null,
        legalPersonID: null,
        legalPersonIDImgs: [],
        legalPersonRole: null,
        legalPersonTitle: null,
        legalPersonTel: null,
        generalManagerName: null,
        generalManagerRole: null,
        generalManagerTitle: null,
        supervisorName: null,
        supervisorTel: null,
        supervisorContactPerson: null,
        supervisorContactTel: null,
        solvency: null,
        totalGuaAmount: null,
        employeeTotal: 0,
        titledTotal: 0,
        titledMedTotal: 0,
        titledSeniorTotal: 0,
        qualifiedTotal: 0,
        regSupervTotal: 0,
        regConstrTotal: 0,
        regCostTotal: 0,
        prjManagerTotal: 0,
        cpaTotal: 0,
        solicitorTotal: 0,
        introduction: null,
        guarRange: null,
        orgChartPath: '',
      },
      calcBalance: null,
      calcCount: null,
      cumulativeBalance: null,
      cumulativeCount: null,
      undergoingBalance: null,
      undergoingCount: null,
      dataToSign: null,
      signMode: 'bin',
      signCallback: null,
      showCertSelectModal: false,
      auditModel: {
        id: this.$route.params.guarantorId,
        code: null,
        pass: true,
        comment: null
      },
      showSetAllowanceModal: false,
      setAllowanceModel: {
        id: this.$route.params.guarantorId,
        allowance: null,
        singleLimit: null,
        minRate: null
      },
      userList: [],
      userColumns: [
        {
          title: '名称',
          key: 'name',
          resizable: true,
          sortable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '账号',
          key: 'user',
          resizable: true,
          sortable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          },
          render: (h, params) => {
            return h('span', {}, params.row.user.loginName) 
          }
        },
        {
          title: '最后登录',
          key: 'user',
          resizable: true,
          sortable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          },
          render: (h, params) => {
            return h('span', {}, params.row.user.lastLoginTime) 
          }
        },
        {
          title: '管理员',
          key: 'isAdmin',
          width: 100,
          sortable: 'custom',
          render: (h, params) => {
            return h('Tag', {
              props: {
                // type: 'dot',
                color: !params.row.isAdmin ? 'default' : 'primary'
              }
            }, !params.row.isAdmin ? '否' : '是')
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let userid = params.row.user.id
                      this.removeUser(userid)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      newUserModel: {
        guarantorId: this.$route.params.guarantorId,
        userId: null,
        isAdmin: true
      },
      users: [],
      myCities: [],
      myCitiesColumns: [
        {
          title: '区域',
          key: 'cityName',
          width: 150,
          resizable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '审核状态',
          key: 'needAudit',
          width: 120,
          render: (h, params) => {
            return h('Tag', {
              props: {
                // type: 'dot',
                color: params.row.needAudit ? 'primary' : 'success'
              }
            }, params.row.needAudit ? '待审核' : '审核通过')
          }
        },
        {
          title: '额度',
          key: 'regionalAllowance',
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', {}, params.row.regionalAllowance ? params.row.regionalAllowance / 100 / 10000 + '万' : '不单独限制')
          }
        },
        {
          title: '单笔额度',
          key: 'singleLimit',
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', {}, params.row.singleLimit ? params.row.singleLimit / 100 / 10000 + '万' : '不单独限制')
          }
        },
        {
          title: '最低费率',
          key: 'minRate',
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', {}, params.row.minRate ? params.row.minRate / 100 / 10000 + '%·月' : '不单独限制')
          }
        },
        {
          title: '品种',
          key: 'varieties',
          render: (h, params) => {
            return h('span', {}, this.getVarietyNames(params.row.varieties))
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              params.row.needAudit ? h('Tooltip', {
                props: {
                  content: '审批',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-checkmark'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.setAuditRegional(params.row)
                    }
                  }
                }, null),
              ]) : null,
              h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      this.initVarieties()
                      this.initCitySelect()
                      this.addCityModel = {
                        cityId: params.row.cityId,
                        guarantorId: params.row.guarantorId,
                        regionalAllowance: params.row.regionalAllowance ? params.row.regionalAllowance / 100 / 10000 : -1,
                        minRate: params.row.minRate ? params.row.minRate / 100 / 10000 : -1,
                        singleLimit: params.row.singleLimit ? params.row.singleLimit / 100 / 10000 : -1,
                        varieties: params.row.varieties,
                        id: params.row.id
                      }
                      this.showAddCityModal = true
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let tId = params.row.id
                      this.removeCity(tId)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      industryRecords: [],
      industryRecordsColumns: [
        {
          title: '区域',
          key: 'cityName',
          width: 150,
          resizable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '行业/领域',
          key: 'industryName',
          width: 150,
          resizable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '审核状态',
          key: 'needAudit',
          width: 120,
          render: (h, params) => {
            return h('Tag', {
              props: {
                // type: 'dot',
                color: params.row.needAudit ? 'primary' : 'success'
              }
            }, params.row.needAudit ? '待审核' : '审核通过')
          }
        },
        {
          title: '额度',
          key: 'regionalAllowance',
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', {}, params.row.regionalAllowance ? params.row.regionalAllowance / 100 / 10000 + '万' : '不单独限制')
          }
        },
        {
          title: '单笔额度',
          key: 'singleLimit',
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', {}, params.row.singleLimit ? params.row.singleLimit / 100 / 10000 + '万' : '不单独限制')
          }
        },
        {
          title: '最低费率',
          key: 'minRate',
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', {}, params.row.minRate ? params.row.minRate / 100 / 10000 + '%·月' : '不单独限制')
          }
        },
        {
          title: '品种',
          key: 'varieties',
          render: (h, params) => {
            return h('span', {}, this.getVarietyNames(params.row.varieties))
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              params.row.needAudit ? h('Tooltip', {
                props: {
                  content: '审批',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-checkmark'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.setAuditIndustrial(params.row)
                    }
                  }
                }, null),
              ]) : null,
              h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      this.initVarieties()
                      this.initIndustrySelect()
                      this.addIndustryModel = {
                        industryId: params.row.industryId,
                        guarantorId: params.row.guarantorId,
                        regionalAllowance: params.row.regionalAllowance ? params.row.regionalAllowance / 100 / 10000 : -1,
                        minRate: params.row.minRate ? params.row.minRate / 100 / 10000 : -1,
                        singleLimit: params.row.singleLimit ? params.row.singleLimit / 100 / 10000 : -1,
                        varieties: params.row.varieties,
                        id: params.row.id
                      }
                      this.showAddIndustryModal = true
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let tId = params.row.id
                      this.removeIndustry(tId)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      cities: [],
      industries: [],
      varieties: [],
      showAddCityModal: false,
      addCityModel: {
        guarantorId: this.$route.params.guarantorId,
        cityId: null,
        varieties: [],
        regionalAllowance: null,
        singleLimit: null,
        minRate: null
      },
      showAddIndustryModal: false,
      addIndustryModel: {
        guarantorId: this.$route.params.guarantorId,
        cityId: null,
        industryId: null,
        varieties: [],
        regionalAllowance: null,
        singleLimit: null,
        minRate: null
      },
      auditRegionalModal: false,
      auditRegionalModel: {
        id: null,
        pass: true,
        singleLimit: null,
        minRate: null,
        regionalAllowance: null,
        varieties: null,
        cityId: null,
        comment: null
      },
      auditIndustrialModal: false,
      auditIndustrialModel: {
        id: null,
        pass: true,
        singleLimit: null,
        minRate: null,
        regionalAllowance: null,
        varieties: null,
        industryId: null,
        comment: null
      },
      imgUrl: null,
      previewImgUrl: null,
      showPreview: false,
      showSetExceptionModal: false,
      setExceptionModel: {
        id: null,
        reason: null,
        facts: null,
        expires: null
      },
      visiblePreviewer: false,
      imageUrls: [],
      startPosition: 0,
      supvPerms: {
        canAuditGuarantor: false,
        canPreAuditGuarantor: false,
        canBlacklistGuarantor: false
      },
    }
  },
  watch: {
    '$route.params.guarantorId': function () {
      this.getGuarantorDetail()
    }
  },
  computed: {
    getAvaliablePercent () {
      if (!this.guarantorModel.allowance || !this.calcBalance) {
        return 0
      }
      return Math.round((this.calcBalance / this.guarantorModel.allowance) * 10000) / 100
    }
  },
  mounted () {
    let verifyObj = document.querySelector('#app > .guarantor-detail')
    if (verifyObj) {
      this.showHeader = true
      try {
        document.body.style = 'overflow: visible !important;'
      } catch (err) {
        console.log(err)
      }
    }
    this.getGuarantorDetail()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    checkRolePermitted (roles) {
      if (!this.$store.getters.userInfo || !this.$store.getters.userInfo.type) {
        return false
      }
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    checkSpvMng (action) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '总监管人') {
        return this.getConfig('ENABLE_GEN_SUPV_MNG_GUARANTOR')
      }
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '监管人') {
        // return this.getConfig('ENABLE_SUPV_MNG_GUARANTOR')
        return this.supvPerms[action]
      }
      return false
    },
    async getMySupervisionPermission () {
      await this.$Api.Supervisor.getMySupervisorPermissions()
      .then((res) => {
        console.log(res)
        Object.assign(this.supvPerms, res)
      })
      .catch(() => {
        this.supvPerms = {
          canAuditGuarantor: false,
          canPreAuditGuarantor: false,
          canBlacklistGuarantor: false
        }
      })
    },
    arrayValidator (rule, value, callback) {
      if (!value || !(value instanceof Array) || !value.length) {
        callback(new Error('没有元素'))
      } else {
        callback()
      }
    },
    getGuarantorDetail () {
      Api.Guarantor.getGuarantorDetail(this.$route.params.guarantorId).then((res) => {
        Object.assign(this.guarantorModel, res)
        this.guarantorStatus = this.guarantorModel.status
        this.procAttachmentsOssKeys(this.guarantorModel.attachments)
        if (!this.showHeader) {
          this.initVarieties()
          this.getGuarantorBalance()
          this.getGuarantorCities()
          this.getGuarantorUsers()
          this.getGuarantorIndustries()
          if (this.checkRolePermitted(['监管人','总监管人'])) {
            this.initUsers()
            this.getMySupervisionPermission()
          }
        }
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    async procOssKey (k) {
      try {
        let url = await this.procOSSUrl(k)
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?')) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        return {
          name: k,
          url,
          type,
          surfix
        }
      } catch (e) {
        console.log(e)
        return false
      }
    },
    procAttachmentsOssKeys (attaches) {
      attaches.forEach((att) => {
        att.url = []
        if (att.filePath) {
          let keys = att.filePath.split(',')
          keys.forEach(async (k, idx) => {
            att.url[idx] = await this.procOssKey(k)
          })
        }
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    getGuarantorBalance () {
      Api.Guarantee.getCalculatedBalance(this.$route.params.guarantorId, null, null)
      .then((res) => {
        this.calcBalance = res.amount
        this.calcCount = res.count
      })
      Api.Guarantee.getCumulativeBalance(this.$route.params.guarantorId, null, null)
      .then((res) => {
        this.cumulativeBalance = res.amount
        this.cumulativeCount = res.count
      })
      Api.Guarantee.getUndergoingBalance(this.$route.params.guarantorId, null, null)
      .then((res) => {
        this.undergoingBalance = res.amount
        this.undergoingCount = res.count
      })
    },
    updateCalculatedBalance () {
      this.calcBalance = 0
      this.calcCount = 0
      Api.Guarantee.updateCalculatedBalance(this.$route.params.guarantorId, null, null)
      .then((res) => {
        this.calcBalance = res.amount
        this.calcCount = res.count
      })
    },
    updateCumulativeBalance () {
      this.cumulativeBalance = 0
      this.cumulativeCount = 0
      Api.Guarantee.updateCumulativeBalance(this.$route.params.guarantorId, null, null)
      .then((res) => {
        this.cumulativeBalance = res.amount
        this.cumulativeCount = res.count
      })
    },
    updateUndergoingBalance () {
      this.undergoingBalance = 0
      this.undergoingCount = 0
      Api.Guarantee.updateUndergoingBalance(this.$route.params.guarantorId, null, null)
      .then((res) => {
        this.undergoingBalance = res.amount
        this.undergoingCount = res.count
      })
    },
    goToStatistics () {
      this.$router.push({
        name: 'Statistics',
        params: {
          guarantor: this.guarantorModel
        }
      })
    },
    goToGuaranteeList () {
      this.$router.push({
        name: 'guarantee-list',
        params: {
          guarantor: this.guarantorModel
        }
      })
    },
    auditPass () {
      this.$Modal.confirm({
        title: '确认操作',
        render: (h) => {
          return h('div', {}, [
            h('p', {}, '确认审核通过该申请么？请填写保证人代码（建议两位大写字母）后提交'),
            h('Input', {
                props: {
                  value: this.auditModel.code,
                  autofocus: true,
                  placeholder: '填写保证人代码（建议两位大写字母）'
                },
                on: {
                  input: (val) => {
                    this.auditModel.code = val
                  }
                }
              }
            )
          ])
        },
        onOk: async () => {
          if (!this.auditModel.code) {
            this.$Notice.error({
              title: '操作失败!',
              desc: '请填写保证人代码'
            })
            return false
          }
          this.loading = true
          this.doAuditGuarantor({
            id: parseInt(this.$route.params.guarantorId),
            code: this.auditModel.code,
            pass: true,
            comment: null
          })
          // this.dataToSign = JSON.stringify({
          //   id: parseInt(this.$route.params.guarantorId),
          //   code: this.auditModel.code,
          //   pass: true,
          //   comment: null
          // })
          // this.signMode = 'normal'
          // this.signCallback = this.doAuditGuarantor
          // this.showCertSelectModal = true
        }
      })
    },
    async doAuditGuarantor (certSigned) {
      await this.$Api.Guarantor.auditGuarantor(this.$route.params.guarantorId, certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getGuarantorDetail()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
      })
    },
    preAuditPass () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认预审通过该保证人么？</p>',
        onOk: async () => {
          this.loading = true
          this.doPreAuditGuarantor({
            id: parseInt(this.$route.params.guarantorId),
            pass: true,
            comment: null
          })
          // this.dataToSign = JSON.stringify({
          //   id: parseInt(this.$route.params.guarantorId),
          //   pass: true,
          //   comment: null
          // })
          // this.signMode = 'normal'
          // this.signCallback = this.doPreAuditGuarantor
          // this.showCertSelectModal = true
        }
      })
    },
    async doPreAuditGuarantor (certSigned) {
      await this.$Api.Guarantor.preAuditGuarantor(this.$route.params.guarantorId, certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getGuarantorDetail()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
      })
    },
    auditDeny () {
      this.$Modal.confirm({
        title: '确认操作',
        render: (h) => {
          return h('div', {}, [
            h('p', {}, '确认退回该申请么？请填写原因后提交'),
            h('Input', {
                props: {
                  value: this.auditModel.comment,
                  autofocus: true,
                  placeholder: '填写退回的原因'
                },
                on: {
                  input: (val) => {
                    this.auditModel.comment = val
                  }
                }
              }
            )
          ])
        },
        onOk: async () => {
          if (!this.auditModel.comment) {
            this.$Notice.error({
              title: '操作失败!',
              desc: '请填写退回原因'
            })
            return false
          }
          this.loading = true
          this.doAuditGuarantor({
            id: parseInt(this.$route.params.guarantorId),
            pass: false,
            comment: this.auditModel.comment
          })
          // this.dataToSign = JSON.stringify({
          //   id: parseInt(this.$route.params.guarantorId),
          //   pass: false,
          //   comment: this.auditModel.comment
          // })
          // this.signMode = 'normal'
          // this.signCallback = this.doAuditGuarantor
          // this.showCertSelectModal = true
        }
      })
    },
    preAuditDeny () {
      this.$Modal.confirm({
        title: '确认操作',
        render: (h) => {
          return h('div', {}, [
            h('p', {}, '确认退回该申请么？请填写原因后提交'),
            h('Input', {
                props: {
                  value: this.auditModel.comment,
                  autofocus: true,
                  placeholder: '填写退回的原因'
                },
                on: {
                  input: (val) => {
                    this.auditModel.comment = val
                  }
                }
              }
            )
          ])
        },
        onOk: async () => {
          if (!this.auditModel.comment) {
            this.$Notice.error({
              title: '操作失败!',
              desc: '请填写退回原因'
            })
            return false
          }
          this.loading = true
          this.doPreAuditGuarantor({
            id: parseInt(this.$route.params.guarantorId),
            pass: false,
            comment: this.auditModel.comment
          })
          // this.dataToSign = JSON.stringify({
          //   id: parseInt(this.$route.params.guarantorId),
          //   pass: false,
          //   comment: this.auditModel.comment
          // })
          // this.signMode = 'normal'
          // this.signCallback = this.doPreAuditGuarantor
          // this.showCertSelectModal = true
        }
      })
    },
    async certSigned (certSigned, callback) {
      console.log(certSigned)
      if (callback) {
        callback(certSigned)
      }
    },
    setAllowance () {
      this.setAllowanceModel = {
        id: this.guarantorModel.id,
        allowance: this.guarantorModel.allowance ? this.guarantorModel.allowance / 100 / 10000 : null,
        singleLimit: this.guarantorModel.singleLimit ? this.guarantorModel.singleLimit / 100 / 10000 : -1,
        minRate: this.guarantorModel.minRate ? this.guarantorModel.minRate / 100 / 10000 : -1
      }
      this.showSetAllowanceModal = true
    },
    submitSetAllowance () {
      this.$refs.setAllowanceForm.validate(async (valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '确认操作',
            content: '<p>确认提交么？</p>',
            onOk: async () => {
              if (!this.setAllowanceModel.id || !this.setAllowanceModel.allowance) {
                this.$Message.error('参数错误')
                return false
              }
              if (this.setAllowanceModel.minRate) {
                this.setAllowanceModel.minRate *= 1000000
              } else {
                this.setAllowanceModel.minRate = -1
              }
              if (this.setAllowanceModel.singleLimit) {
                this.setAllowanceModel.singleLimit *= 100 * 10000
              } else {
                this.setAllowanceModel.singleLimit = -1
              }
              if (this.setAllowanceModel.allowance) {
                this.setAllowanceModel.allowance *= 100 * 10000
              }
              this.doSubmitSetAllowance(this.setAllowanceModel)
              // this.dataToSign = JSON.stringify(this.setAllowanceModel)
              // this.signMode = 'normal'
              // this.signCallback = this.doSubmitSetAllowance
              // this.showCertSelectModal = true
            }
          })
        }
      })
    },
    async doSubmitSetAllowance (certSigned) {
      this.loading = true
      this.$Spin.show()
      await this.$Api.Guarantor.setAllowance(certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.guarantorModel.allowance = this.setAllowanceModel.allowance
        this.guarantorModel.singleLimit = this.setAllowanceModel.singleLimit
        this.guarantorModel.minRate = this.setAllowanceModel.minRate
        this.closeSetAllowanceModal()
        this.getGuarantorDetail()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.closeSetAllowanceModal()
      })
    },
    closeSetAllowanceModal () {
      this.setAllowanceModel = {
        id: this.$route.params.guarantorId,
        allowance: null,
        singleLimit: null,
        minRate: null
      }
      this.showSetAllowanceModal = false
    },
    initVarieties () {
      this.$Api.Guarantee.getGuaranteeVarieties('ALL')
      .then((res) => {
        this.varieties = res
      })
      .catch(err => {
        this.$Message.error(err.message)
      })
    },
    getVarietyName (varietyId, isFullName = false) {
      if (this.varieties && this.varieties.length) {
        let v = this.varieties.find(o => o.id === varietyId)
        if (!v) {
          return '未知'
        }
        if (isFullName) {
          return v.fullName
        } else {
          return v.name
        }
      }
    },
    getVarietyNames (input) {
      if (input instanceof Array) {
        let names = []
        input.forEach((i) => {
          let v = this.varieties.find(t => t.id === i)
          names.push(v.name)
        })
        return names.join(',')
      } else {
        let v = this.varieties.find(t => t.id === input)
        return v ? v.name : null
      }
    },
    getVarietyTagColor (varietyId) {
      return this.$common.guaranteeVarietyColor[varietyId]
    },
    getGuarantorUsers () {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$Spin.show()
        Api.Guarantor.getGuarantorUsers(this.guarantorModel.id).then((users) => {
          this.userList = users
          this.loading = false
          this.$Spin.hide()
          resolve(users)
        }).catch(err => {
          this.$Message.error('获取用户列表失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    initUsers () {
      Api.Auth(this).listUsersByType(3).then((res) => {
        let data = res.data.map((c) => {
          return {
            id: c.id,
            value: c.id,
            label: `${c.displayName}(${c.loginName})`
          }
        })
        this.users = data
      }).catch(err => {
        this.$Message.error('获取用户列表失败!' + err.message)
      })
    },
    addUser () {
      this.$refs.newUserForm.validate(async (valid) => {
        if (valid) {
          Api.Guarantor.addUesrToGuarantor(
            this.$route.params.guarantorId,
            this.newUserModel.userId,
            this.newUserModel.isAdmin
          ).then(() => {
            this.$Message.success('操作成功!')
            this.getGuarantorDetail()
          }).catch(err => {
            this.$Message.error('操作失败!' + err.message)
          })
        }
      })
    },
    removeUser (userId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该用户么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await Api.Guarantor.removeUesrFromGuarantor(this.$route.params.guarantorId, userId).catch(err => {
            this.$Message.error('操作失败!' + err.message)
            return null
          })
          this.$Message.success('操作成功!')
          this.userList.splice(
            this.userList
            .findIndex(o => {return o.user.id === userId}), 1)
        },
        onCancel: () => {
        }
      })
    },
    initIndustrySelect () {
      this.$Api.Industry.listIndustries({
      }, 1, 1000).then((res) => {
        let data = res.data.map((c) => {
          return {
            id: c.id,
            value: c.id,
            label: c.name
          }
        })
        this.industries = data
      }).catch(err => {
        this.$Message.error('获取行业列表失败!' + err.message)
      })
    },
    initCitySelect (...args) {
      this.$store.dispatch('setSmsVerifierCallbackFn', this.initCitySelect)
      this.$store.dispatch('setSmsVerifierCallbackArgs', args)
      this.$Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      this.$Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.addCityModel.cityId = val[val.length - 1]
      } else {
        this.addCityModel.cityId = val
      }
    },
    cityIndustrySelected (val) {
      if (val instanceof Array) {
        this.addIndustryModel.cityId = val[val.length - 1]
      } else {
        this.addIndustryModel.cityId = val
      }
    },
    getGuarantorCities () {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$Spin.show()
        Api.Guarantor.getGuarantorCities(this.guarantorModel.id).then((cities) => {
          this.myCities = cities
          this.loading = false
          this.$Spin.hide()
          resolve(cities)
        }).catch(err => {
          this.$Message.error('获取城市列表失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    setAddCity () {
      this.initVarieties()
      this.initCitySelect()
      this.addCityModel = {
        guarantorId: this.guarantorModel.id,
        cityId: null,
        varieties: [],
        regionalAllowance: -1,
        singleLimit: -1,
        minRate: -1
      }
      this.showAddCityModal = true
    },
    submitAddCity () {
      this.$refs.addCityForm.validate(async (valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '确认操作',
            content: '<p>确认提交么？</p>',
            onOk: async () => {
              if (!this.addCityModel.guarantorId || !this.addCityModel.cityId) {
                this.$Message.error('参数错误')
                return false
              }
              if (this.addCityModel.minRate && this.addCityModel.minRate >= 0) {
                this.addCityModel.minRate *= 1000000
              } else {
                this.addCityModel.minRate = null
              }
              if (this.addCityModel.singleLimit && this.addCityModel.singleLimit >= 0) {
                this.addCityModel.singleLimit *= 100 * 10000
              } else {
                this.addCityModel.singleLimit = null
              }
              if (this.addCityModel.regionalAllowance && this.addCityModel.regionalAllowance >= 0) {
                this.addCityModel.regionalAllowance *= 100 * 10000
              } else {
                this.addCityModel.regionalAllowance = null
              }
              if (this.addCityModel.id) {
                this.doSubmitUpdateCity(this.addCityModel)
              } else {
                this.doSubmitAddCity(this.addCityModel)
              }
              // this.dataToSign = JSON.stringify(this.addCityModel)
              // this.signMode = 'normal'
              // this.signCallback = this.doSubmitAddCity
              // this.showCertSelectModal = true
            }
          })
        }
      })
    },
    async doSubmitAddCity (certSigned) {
      this.loading = true
      this.$Spin.show()
      await this.$Api.Guarantor.addGuarantorToCity(certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getGuarantorCities()
        this.closeAddCityModal()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.closeAddCityModal()
      })
    },
    async doSubmitUpdateCity (certSigned) {
      this.loading = true
      this.$Spin.show()
      await this.$Api.Guarantor.updateGuarantorCity(certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getGuarantorCities()
        this.closeAddCityModal()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.closeAddCityModal()
      })
    },
    closeAddCityModal () {
      this.addCityModel = {
        guarantorId: this.guarantorModel.id,
        cityId: null,
        varieties: [],
        regionalAllowance: -1,
        singleLimit: -1,
        minRate: -1
      }
      this.showAddCityModal = false
    },
    getGuarantorIndustries () {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$Spin.show()
        Api.Guarantor.getGuarantorIndustries(this.guarantorModel.id).then((industries) => {
          this.industryRecords = industries
          this.loading = false
          this.$Spin.hide()
          resolve(industries)
        }).catch(err => {
          this.$Message.error('获取行业列表失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    setAddIndustry () {
      this.initVarieties()
      this.initCitySelect()
      this.initIndustrySelect()
      this.addIndustryModel = {
        guarantorId: this.guarantorModel.id,
        cityId: null,
        industryId: null,
        varieties: [],
        regionalAllowance: -1,
        singleLimit: -1,
        minRate: -1
      }
      this.showAddIndustryModal = true
    },
    submitAddIndustry () {
      this.$refs.addIndustryForm.validate(async (valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '确认操作',
            content: '<p>确认提交么？</p>',
            onOk: async () => {
              if (!this.addIndustryModel.guarantorId || !this.addIndustryModel.industryId) {
                this.$Message.error('参数错误')
                return false
              }
              if (this.addIndustryModel.minRate && this.addIndustryModel.minRate >= 0) {
                this.addIndustryModel.minRate *= 1000000
              } else {
                this.addIndustryModel.minRate = null
              }
              if (this.addIndustryModel.singleLimit && this.addIndustryModel.singleLimit >= 0) {
                this.addIndustryModel.singleLimit *= 100 * 10000
              } else {
                this.addIndustryModel.singleLimit = null
              }
              if (this.addIndustryModel.regionalAllowance && this.addIndustryModel.regionalAllowance >= 0) {
                this.addIndustryModel.regionalAllowance *= 100 * 10000
              } else {
                this.addIndustryModel.regionalAllowance = null
              }
              if (this.addIndustryModel.id) {
                this.doSubmitUpdateIndustry(this.addIndustryModel)
              } else {
                this.doSubmitAddIndustry(this.addIndustryModel)
              }
              // this.dataToSign = JSON.stringify(this.addIndustryModel)
              // this.signMode = 'normal'
              // this.signCallback = this.doSubmitAddIndustry
              // this.showCertSelectModal = true
            }
          })
        }
      })
    },
    async doSubmitAddIndustry (certSigned) {
      this.loading = true
      this.$Spin.show()
      await this.$Api.Guarantor.addGuarantorToIndustry(certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getGuarantorIndustries()
        this.closeAddIndustryModal()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.closeAddIndustryModal()
      })
    },
    async doSubmitUpdateIndustry (certSigned) {
      this.loading = true
      this.$Spin.show()
      await this.$Api.Guarantor.updateGuarantorIndustry(certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getGuarantorIndustries()
        this.closeAddIndustryModal()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.closeAddIndustryModal()
      })
    },
    closeAddIndustryModal () {
      this.addIndustryModel = {
        guarantorId: this.guarantorModel.id,
        industryId: null,
        varieties: [],
        regionalAllowance: -1,
        singleLimit: -1,
        minRate: -1
      }
      this.showAddIndustryModal = false
    },
    removeCity (tid) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除么？</p>',
        onOk: async () => {
          this.loading = true
          this.$Spin.show()
          await this.$Api.Guarantor.removeCityFromGuarantor(tid)
          .then(() => {
            // console.log(payload)
            this.$Message.success('操作成功!')
            let idx = this.myCities.findIndex(o => o.id === tid)
            this.myCities.splice(idx, 1)
            this.loading = false
            this.$Spin.hide()
          })
          .catch(err => {
            this.loading = false
            this.$Spin.hide()
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
          })
        }
      })
    },
    removeIndustry (tid) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除么？</p>',
        onOk: async () => {
          this.loading = true
          this.$Spin.show()
          await this.$Api.Guarantor.removeIndustryFromGuarantor(tid)
          .then(() => {
            // console.log(payload)
            this.$Message.success('操作成功!')
            let idx = this.industryRecords.findIndex(o => o.id === tid)
            this.industryRecords.splice(idx, 1)
            this.loading = false
            this.$Spin.hide()
          })
          .catch(err => {
            this.loading = false
            this.$Spin.hide()
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
          })
        }
      })
    },
    setAuditRegional (item) {
      this.initVarieties()
      this.initCitySelect()
      this.auditRegionalModel = {
        id: item.id,
        pass: true,
        minRate: item.minRate ? item.minRate / 100 / 10000 : -1,
        singleLimit: item.singleLimit ? item.singleLimit / 100 / 10000 : -1,
        regionalAllowance: item.regionalAllowance ? item.regionalAllowance / 100 / 10000 : -1,
        varieties: item.varieties,
        cityId: item.cityId,
        comment: null
      }
      this.auditRegionalModal = true
    },
    submitAuditRegional () {
      this.$refs.auditRegionalForm.validate(async (valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '确认操作',
            content: '<p>确认提交么？</p>',
            onOk: async () => {
              if (!this.auditRegionalModel.id) {
                this.$Message.error('参数错误')
                return false
              }
              if (this.auditRegionalModel.minRate && this.auditRegionalModel.minRate >= 0) {
                this.auditRegionalModel.minRate *= 1000000
              } else {
                this.auditRegionalModel.minRate = null
              }
              if (this.auditRegionalModel.singleLimit && this.auditRegionalModel.singleLimit >= 0) {
                this.auditRegionalModel.singleLimit *= 100 * 10000
              } else {
                this.auditRegionalModel.singleLimit = null
              }
              if (this.auditRegionalModel.regionalAllowance && this.auditRegionalModel.regionalAllowance >= 0) {
                this.auditRegionalModel.regionalAllowance *= 100 * 10000
              } else {
                this.auditRegionalModel.regionalAllowance = null
              }
              this.doSubmitAuditRegionalModel(this.auditRegionalModel)
              // this.dataToSign = JSON.stringify(this.auditRegionalModel)
              // this.signMode = 'normal'
              // this.signCallback = this.doSubmitAuditRegionalModel
              // this.showCertSelectModal = true
            }
          })
        }
      })
    },
    async doSubmitAuditRegionalModel (certSigned) {
      this.loading = true
      this.$Spin.show()
      await this.$Api.Guarantor.auditRegionalGuarantor(certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getGuarantorCities()
        this.closeAuditRegionalModal()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.closeAuditRegionalModal()
      })
    },
    closeAuditRegionalModal () {
      this.auditRegionalModel = {
        id: null,
        pass: true,
        singleLimit: null,
        minRate: null,
        regionalAllowance: null,
        varieties: null,
        cityId: null,
        comment: null
      }
      this.auditRegionalModal = false
    },
    setAuditIndustrial (item) {
      this.initVarieties()
      this.initCitySelect()
      this.initIndustrySelect()
      this.auditIndustrialModel = {
        id: item.id,
        pass: true,
        minRate: item.minRate ? item.minRate / 100 / 10000 : -1,
        singleLimit: item.singleLimit ? item.singleLimit / 100 / 10000 : -1,
        regionalAllowance: item.regionalAllowance ? item.regionalAllowance / 100 / 10000 : -1,
        varieties: item.varieties,
        cityId: item.cityId,
        industryId: item.industryId,
        comment: null
      }
      this.auditIndustrialModal = true
    },
    submitAuditIndustrial () {
      this.$refs.auditIndustrialForm.validate(async (valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '确认操作',
            content: '<p>确认提交么？</p>',
            onOk: async () => {
              if (!this.auditIndustrialModel.id) {
                this.$Message.error('参数错误')
                return false
              }
              if (this.auditIndustrialModel.minRate && this.auditIndustrialModel.minRate >= 0) {
                this.auditIndustrialModel.minRate *= 1000000
              } else {
                this.auditIndustrialModel.minRate = null
              }
              if (this.auditIndustrialModel.singleLimit && this.auditIndustrialModel.singleLimit >= 0) {
                this.auditIndustrialModel.singleLimit *= 100 * 10000
              } else {
                this.auditIndustrialModel.singleLimit = null
              }
              if (this.auditIndustrialModel.regionalAllowance && this.auditIndustrialModel.regionalAllowance >= 0) {
                this.auditIndustrialModel.regionalAllowance *= 100 * 10000
              } else {
                this.auditIndustrialModel.regionalAllowance = null
              }
              this.doSubmitAuditIndustrial(this.auditIndustrialModel)
              // this.dataToSign = JSON.stringify(this.auditIndustrialModel)
              // this.signMode = 'normal'
              // this.signCallback = this.doSubmitAuditIndustrial
              // this.showCertSelectModal = true
            }
          })
        }
      })
    },
    async doSubmitAuditIndustrial (certSigned) {
      console.log(certSigned)
      this.loading = true
      this.$Spin.show()
      await this.$Api.Guarantor.auditIndustrialGuarantor(certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getGuarantorIndustries()
        this.closeAuditIndustrialModal()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.closeAuditIndustrialModal()
      })
    },
    closeAuditIndustrialModal () {
      this.auditIndustrialModel = {
        id: null,
        pass: true,
        singleLimit: null,
        minRate: null,
        regionalAllowance: null,
        varieties: null,
        industryId: null,
        comment: null
      }
      this.auditIndustrialModal = false
    },
    closeSetExceptionModal () {
      this.setExceptionModel = {
        id: null,
        reason: null,
        facts: null,
        expires: null
      }
      this.showSetExceptionModal = false
    },
    submitSetException () {
      this.$refs.setExceptionForm.validate(async (valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '确认操作',
            content: '<p>确认设置黑名单么？</p>',
            onOk: async () => {
              if (!this.setExceptionModel.id) {
                this.setExceptionModel.id = this.$route.params.guarantorId
              }
              this.doSetException(this.setExceptionModel)
              // this.dataToSign = JSON.stringify(this.setExceptionModel)
              // this.signMode = 'normal'
              // this.signCallback = this.doSetException
              // this.showCertSelectModal = true
            }
          })
        }
      })
    },
    async doSetException (certSigned) {
      console.log(certSigned)
      this.loading = true
      this.$Spin.show()
      await this.$Api.Guarantor.setException(certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.closeSetExceptionModal()
        this.getGuarantorDetail()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.closeSetExceptionModal()
      })
    },
    submitRemoveException () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认解除黑名单么？</p>',
        onOk: async () => {
          if (!this.setExceptionModel.id) {
            this.setExceptionModel.id = this.$route.params.guarantorId
          }
          this.doRemoveException(this.setExceptionModel)
          // this.dataToSign = JSON.stringify(this.setExceptionModel)
          // this.signMode = 'normal'
          // this.signCallback = this.doRemoveException
          // this.showCertSelectModal = true
        }
      })
    },
    async doRemoveException (certSigned) {
      console.log(certSigned)
      this.loading = true
      this.$Spin.show()
      await this.$Api.Guarantor.removeException(certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getGuarantorDetail()
        this.closeSetExceptionModal()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.closeSetExceptionModal()
      })
    },
    handleImgPreview (list, index) {
      this.imageUrls = list.map((l) => {return l.url})
      this.visiblePreviewer = true
      this.startPosition = index
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  background: linear-gradient(45deg, #3d3294, #3098ff);
  padding: 0;
}
.top-bar {
  background: transparent;
  padding: 0;
}
.top-bar-search {
  display: inline-block;
  width: 100px;
  margin-right: 20px;
  transition: all linear .3s;
  &.expand {
    width: 300px;
  }
}
.layout-logo {
  height: 50px;
  // background: #5b6270;
  color: #fefefe;
  text-align: center;
  border-radius: 3px;
  float: left;
  position: relative;
  top: 5px;
  margin-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  .site-name-area {
    line-height: initial;
    text-align: left;
  }
}
.layout-nav{
  margin: 0 auto;
  margin-right: 20px;
  display: inline-block;
}
.detail-header {
  margin-bottom: 40px;
  .header-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
}
.attachments {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}
.attachment-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 4px;
  transition: all .2s ease-in-out;
  padding: 3px;
  border: 1px solid #d2d2d2;
  position: relative;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    cursor: pointer;
    width: 100%;
  }
  .attachment-thumb-cover{
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    transition: all .3s linear;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &:hover .attachment-thumb-cover{
    opacity: 1;
  }
  .attachment-thumb-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
</style>
